import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const authToken = Cookies.get("authToken");

let decoded = null;
if (authToken) {
  try {
    decoded = jwtDecode(authToken);
  } catch (e) {
    console.error("Invalid token");
  }
}

const initialState = {
  user: decoded ? decoded.user || null : null,
  role: decoded ? decoded.role || null : null,
  userId: decoded ? decoded.userId || null : null,
  token: authToken || null,
  isAuthenticated: !!authToken,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: "studentAuth",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.userId = action.payload.userId;
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.role = null;
      state.userId = null;
      state.user = null;
      state.token = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout,clearError } =
  authSlice.actions;
export default authSlice.reducer;
